import type { ConnectionFeedback, operations } from '..';
import { api } from '../api';
import { provider, tags } from '../tags';

export type CreateConnectionFeedbackArgs = {
  data: operations['createConnectionFeedback']['requestBody']['content']['application/json'];
};

export const connectionFeedbackApi = api.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    feedback: builder.query<ConnectionFeedback, string>({
      query: (id: string) => `api/expert-network/connection-feedback/${id}/`,
      providesTags: provider<ConnectionFeedback>(tags.connectionFeedback),
    }),
    createFeedback: builder.mutation<ConnectionFeedback, CreateConnectionFeedbackArgs>({
      query: ({ data }) => ({
        url: 'api/expert-network/connection-feedback/',
        body: data,
        method: 'POST',
      }),
      invalidatesTags: (result, _error, args) =>
        result ? [{ type: tags.connectionRequest, id: args.data.connection_request }] : [],
    }),
  }),
});
